import { FC } from "react";

import { Tag } from "capitalrx-components-2.0/lib/general";
import { Shelf, Stack, useResponsive } from "capitalrx-components-2.0/lib/layout";
import { Regular, Semibold } from "capitalrx-components-2.0/lib/typography";
import { formatDate, formatDollars } from "capitalrx-utilities";

import { Finance } from "@/api/interfaces";
import { PROVIDER_MANAGEMENT_LAYOUT } from "@/constants";

import styles from "./MedicalClaimsList.module.scss";

const statusLabels: Record<string, string> = {
  "in_progress": "In Progress",
  "approved": "Approved",
  "partially_approved": "Partially Approved",
  "denied": "Denied",
};

const statusColors: Record<string, string> = {
  "in_progress": "#313E48",
  "approved": "#317861",
  "partially_approved": "#313E48",
  "denied": "#B8222A",
};

const voidTag = <Tag style={{ height: "20px" }} type="system-high-contrast">Issued</Tag>;
const clearedTag = <Tag style={{ height: "20px" }} type="success-high-contrast">Cleared</Tag>;

export const MedicalClaimRow: FC<Partial<Finance.MedicalClaimMemberSchema>> = ({ start_date, submission_date, claim_status, payment_amount, issue_date, payment_is_void, payment_is_cleared }) => {
  const { isCompressed } = useResponsive(PROVIDER_MANAGEMENT_LAYOUT);


  return (
    <>
    {isCompressed && (
      <Stack spacing="small" className={styles.ClaimRow}>
        <Semibold>Service Start: {formatDate(start_date, "MM/DD/YYYY", true)}</Semibold>
        <Shelf>
          <Regular>Submission Date</Regular>
          <Shelf.Spacer />
          <Semibold>{formatDate(submission_date, "MM/DD/YYYY", true)}</Semibold>
        </Shelf>
        <Shelf>
          <Regular>Claim Status</Regular>
          <Shelf.Spacer />
          <Semibold style={{ color: statusColors[claim_status] }}>{statusLabels[claim_status]}</Semibold>
        </Shelf>
        <Shelf>
          <Regular>Paid Amount</Regular>
          <Shelf.Spacer />
          <Semibold>{payment_amount || payment_amount === 0 ? formatDollars(payment_amount) : "--"}</Semibold>
        </Shelf>
        <Shelf>
          <Regular>Payment Issued</Regular>
          <Shelf.Spacer />
          <Semibold>{formatDate(issue_date, "MM/DD/YYYY", true)}</Semibold>
        </Shelf>
        <Shelf>
          <Regular>Payment Status</Regular>
          <Shelf.Spacer />
          {payment_is_void && voidTag}
          {payment_is_cleared && clearedTag}
        </Shelf>
      </Stack>
    )}
    {!isCompressed && (
      <Shelf spacing="medium-large" className={styles.ClaimRow}>
        <Stack alignment="left" spacing="mini" style={{ width: "122px" }}>
          <Regular>{formatDate(start_date, "MM/DD/YYYY", true)}</Regular>
        </Stack>
        <Shelf.Spacer />
        <Stack alignment="left" spacing="mini" style={{ width: "138px" }}>
          <Regular>{formatDate(submission_date, "MM/DD/YYYY", true)}</Regular>
        </Stack>
        <Shelf.Spacer />
        <Stack alignment="left" spacing="mini" style={{ width: "241px" }}>
          <Regular style={{ color: statusColors[claim_status] }}>{statusLabels[claim_status]}</Regular>
        </Stack>
        <Shelf.Spacer />
        <Stack alignment="right" spacing="mini" style={{ width: "76px" }}>
          <Regular>{payment_amount || payment_amount === 0 ? formatDollars(payment_amount) : "--"}</Regular>
        </Stack>
        <Shelf.Spacer />
        <Stack alignment="left" spacing="mini" style={{ width: "111px" }}>
          <Regular>{formatDate(issue_date, "MM/DD/YYYY", true)}</Regular>
        </Stack>
        <Shelf.Spacer />
        <Stack alignment="center" spacing="mini" style={{ width: "94px" }}>
          {payment_is_void && voidTag}
          {payment_is_cleared && clearedTag}
        </Stack>
      </Shelf>
    )}
    </>
  );
};
